"use client";

import Link from "next/link";
import { Suspense, type ReactNode } from "react";
import { useSearchParams } from "next/navigation";
import { useSitePathname } from "@/components/site/site-prefix-context";
import { useTranslations } from "next-intl";

import { MEMBER_LOGIN_PATH, buildMemberLoginHref } from "@/lib/auth/login-redirect";

type SiteLoginLinkProps = {
  className?: string;
  children?: ReactNode;
};

function SiteLoginLinkInner({ className, children }: SiteLoginLinkProps) {
  const t = useTranslations("site.common");
  const pathname = useSitePathname();
  const searchParams = useSearchParams();
  const query = searchParams.toString();

  return (
    <Link
      href={buildMemberLoginHref({
        from: `${pathname}${query ? `?${query}` : ""}`,
      })}
      className={className}
    >
      {children ?? t("login")}
    </Link>
  );
}

export function SiteLoginLink({ className, children }: SiteLoginLinkProps) {
  const t = useTranslations("site.common");

  return (
    <Suspense
      fallback={
        <Link href={MEMBER_LOGIN_PATH} className={className}>
          {children ?? t("login")}
        </Link>
      }
    >
      <SiteLoginLinkInner className={className}>{children}</SiteLoginLinkInner>
    </Suspense>
  );
}
